<template>
  <main>
    <v-container fluid class="pa-5 pb-16 elevation-1">
      <!-- Título que abarca horizontalmente -->
      <v-sheet class="pa-4 w-100" color="#194c9b" elevation="2" rounded>
        <h1 class="text-h4 font-weight-bold">
          <v-btn icon color="blue">
            <v-icon>mdi-brain</v-icon>
          </v-btn>
          {{ $t("model") }} - {{ $route.query.projectName }}
        </h1>
      </v-sheet>
      <v-stepper v-if="tipoArchivo == 'audio'" v-model="step" alt-labels>
        <v-stepper-header>
          <v-stepper-item :title="tituloCargaHeader" :value="1" :complete="step > 1" :class="getStepClass(1)">
          </v-stepper-item>
          <v-divider></v-divider>
          <v-stepper-item :title="$t('trans')" :value="2" :complete="step > 2" :class="getStepClass(2)">
          </v-stepper-item>
          <v-divider></v-divider>
          <v-stepper-item :title="$t('model')" :value="3" :complete="step > 3" :class="getStepClass(3)">
          </v-stepper-item>
        </v-stepper-header>
      </v-stepper>
      <v-stepper v-else v-model="step" alt-labels>
        <v-stepper-header>
          <v-stepper-item :title="tituloCargaHeader" :value="1" :complete="step > 1" :class="getStepClass(1)">
          </v-stepper-item>
          <v-divider></v-divider>
          <v-stepper-item :title="$t('model')" :value="3" :complete="step > 3" :class="getStepClass(3)">
          </v-stepper-item>
        </v-stepper-header>
      </v-stepper>


      <!-- Cards stepper 1-->
      <v-card v-if="step === 1" elevation="2" class="pa-4 mt-5">
        <v-card-title class="bg-grey-lighten-4 text-center">
          {{ tituloCargaHeader }}
        </v-card-title>
        <v-card-text>
          <v-snackbar v-if="flagButton || audionot" v-model="showSnackbar" :color="snackbarColor" timeout="4000"
            location="top right" position="fixed">
            <v-icon left class="mr-2">mdi-alert-circle</v-icon>
            {{ snackbarMessage }}
          </v-snackbar>
          <div class="mb-4">
            <label class="text-subtitle-1 font-weight-medium">
              {{ $t("seleccionar") }}
            </label>
            <v-row>
              <!-- $t('Texto'), $t('his_user') -->
              <v-col cols="12" md="6">
                <v-select label="Selecciona el tipo de archivo" v-model="tipoArchivo" :items="items" item-title="label"
                  item-value="value" prepend-inner-icon="mdi-file" />
              </v-col>
            </v-row>
            <v-row v-if="tipoArchivo === 'audio'">
              <v-col cols="12" md="6">
                <v-file-input v-model="archivo" title="Audio / Video" prepend-icon="mdi-paperclip" outlined show-size
                  counter chips dense color="blue lighten-1" background-color="grey lighten-2"
                  accept="video/*,audio/*,.mp4,.mov,.webm,.mp3,.wav,.m4a" :rules="[validateMedia]"
                  class="mb-4 rounded-lg elevation-1"
                  style="padding-top: 2%; padding-right: 2%; padding-bottom: 1%"></v-file-input>
                <!-- Nueva linea para revisar la persistencia -->
                <div v-if="evidencia?.video_url" class="mb-2">
                  <strong>Archivo actual:</strong>
                  {{ nombreArchivo(evidencia.video_url) }}
                </div>
                <div v-if="evidencia.video_url != 'No hay aun archivo'" class="mb-2">
                  <video v-if="evidencia.video_url" :key="evidencia.video_url" controls :src="evidencia.video_url"
                    style="width: 100%; max-width: 500px"></video>
                </div>
              </v-col>
              <v-col cols="12" md="2" class="d-flex align-center icon-padding">
                <v-icon size="80">mdi-notebook-edit-outline</v-icon>
              </v-col>
              <v-col cols="12" md="3" class="d-flex align-center">
                <v-btn :disabled="!archivo && !evidencia?.video_url" color="#005FA9" class="mt-3 text-none"
                  style="white-space: normal; line-height: 1.2; min-height: 48px" @click.prevent="procesarVideo()"
                  block>{{ $t("obtener") }}</v-btn>
              </v-col>
            </v-row>
            <v-row v-else-if="tipoArchivo === 'texto'">
              <v-col cols="12" md="6">
                <v-file-input v-model="archivo" title="(pdf,txt)" prepend-icon="mdi-paperclip" outlined show-size
                  counter chips dense color="blue lighten-1" background-color="grey lighten-2"
                  accept=".txt,.csv,.pdf,.xlsx,.docx" class="mb-4 rounded-lg elevation-1"
                  style="padding-top: 2%; padding-right: 2%; padding-bottom: 1%"></v-file-input>
              </v-col>
              <v-col cols="12" md="2" class="d-flex align-center icon-padding">
                <v-icon size="80">mdi-notebook-edit-outline</v-icon>
              </v-col>
              <v-col cols="12" md="3" class="d-flex align-center">
                <v-btn :disabled="!archivo || procesando" color="#005FA9" class="mt-3" @click.prevent="procesarVideo()"
                  block>{{ $t("obtener2") }}</v-btn>
              </v-col>
            </v-row>
            <v-row v-else-if="tipoArchivo === 'historia_usuario'">
              <v-col cols="12" md="6">
                <v-radio-group v-model="modoHistoria" inline hide-details class="mb-2"
                  @update:modelValue="onCambiarModoHistoria">
                  <v-radio label="Escribir historia" value="texto" />
                  <v-radio label="Cargar archivo" value="archivo" />
                </v-radio-group>

                <v-textarea v-if="modoHistoria === 'texto'" label="Escribe tu Historia de usuario"
                  v-model="historiaTexto" prepend-inner-icon="mdi-pencil" color="blue lighten-1"
                  background-color="grey lighten-2" class="mb-2 rounded-lg elevation-1"
                  style="padding-top: 2%; padding-right: 2%; padding-bottom: 1%" auto-grow rows="6" />

                <v-file-input v-else v-model="historiaArchivo" label="Cargar archivo (txt, docx, pdf)"
                  prepend-icon="mdi-paperclip" outlined show-size counter chips dense color="blue lighten-1"
                  background-color="grey lighten-2" accept=".txt,.docx,.pdf" class="mb-2 rounded-lg elevation-1" />
                <div v-if="namefile && textoEsDeDocumento"
                  class="text-caption text-medium-emphasis mb-4 d-flex align-center">
                  <v-icon size="16" class="mr-1">mdi-file-upload-outline</v-icon>
                  Subido: {{ namefile }}
                </div>
              </v-col>
              <v-col cols="12" md="2" class="d-flex align-center icon-padding">
                <v-icon size="80">mdi-notebook-edit-outline</v-icon>
              </v-col>
              <v-col cols="12" md="3" class="d-flex align-center">
                <v-btn :disabled="(!(historiaTexto && historiaTexto.trim()) &&
                    !historiaArchivo) ||
                  procesando
                  " color="#005FA9" class="mt-3" @click.prevent="obtenerTextoHistoria()" block>{{ $t("obtener2")
                  }}</v-btn>
              </v-col>
            </v-row>
            <!-- El texto guardado no es del documento sino del audio -->
            <v-alert v-if="
              tipoArchivo === 'historia_usuario' &&
              textoExtraido &&
              !textoEsDeDocumento
            " type="warning" variant="tonal" density="compact" class="mt-2">
              El texto guardado no corresponde al documento (es del audio).
              Vuelve a procesar "Obtener texto".
            </v-alert>
            <!-- Preview del texto obtenido (documento o historia escrita) -->
            <v-row v-if="tipoArchivo === 'historia_usuario' && textoExtraido && textoEsDeDocumento">
              <v-col cols="12" md="11">
                <label class="text-subtitle-2 font-weight-medium">
                  Texto obtenido (puedes editarlo antes de procesar)
                </label>
                <v-textarea v-model="textoExtraido" variant="outlined" auto-grow rows="8" class="mt-2 rounded-lg" />
              </v-col>
            </v-row>
          </div>
          <v-divider v-if="flagButton && evidencia.audio_url" class="my-4"></v-divider>

          <div v-if="flagButton && evidencia.audio_url && !modoHistoria" class="audio-wrapper mt-4">
            <label class="audio-label">{{ $t("generado") }}</label>
            <audio :src="audioUrl" controls class="audio-player"></audio>
          </div>


          <div class="d-flex justify-space-between align-center">
            <v-btn color="#005FA9" class="mt-3" @click.prevent="returnProyects">
              Regresar a Proyectos
            </v-btn>
            <v-btn color="#005FA9" class="mt-3" :disabled="!puedeAvanzarPaso1" @click.prevent="setStep">{{ $t("next") }}
              >></v-btn>
          </div>

          <v-divider v-if="flagButton" class="my-4"></v-divider>
        </v-card-text>
      </v-card>
      <!-- Cards stepper 2 -->
      <v-card v-if="step === 2 && tipoArchivo === 'audio'" elevation="2" class="pa-4 mt-5">
        <v-card-text>
          <v-snackbar v-if="flagButton || audionot" v-model="showSnackbar" :color="snackbarColor" timeout="4000"
            location="top right" position="fixed">
            <v-icon left class="mr-2">mdi-alert-circle</v-icon>
            {{ snackbarMessage }}
          </v-snackbar>
          <div class="mb-4">
            <label class="text-subtitle-1 font-weight-medium">
              Muestra Transcripcion</label>
            <div>
              <small class="grey--text text--darken-1">
                * Esta acción procesará el audio y descargará la transcripción
                en formato .txt.
              </small>
            </div>
            <v-divider class="my-4"></v-divider>
            <v-row justify="center" class="mb-2">
              <v-col cols="auto">
                <v-btn color="primary" @click.prevent="downloadFile">
                  Procesar Transcripción
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <v-alert v-if="!transcripcionEsDelAudio" type="warning" variant="tonal" density="compact" class="mb-2">
            La transcripción guardada no corresponde al audio (es del
            documento). Vuelve a procesar la transcripción del audio.
          </v-alert>
          <v-divider v-if="flagButton" class="my-4"></v-divider>
          <div class="d-flex justify-space-between align-center">
            <v-btn color="#005FA9" class="mt-3" @click.prevent="returnStep">
              Regresar</v-btn>
            <v-btn v-if="flagButton" color="#005FA9" class="mt-3" :disabled="!transcripcionEsDelAudio
              // ||
              // (useKnowledgeHub && !knowledgeHubDone)
              " @click.prevent="setStep">{{ $t("next") }} >></v-btn>
          </div>

          <!-- Visor del archivo -->
          <v-sheet v-if="contenidoArchivo && transcripcionEsDelAudio" class="mt-4 pa-2" elevation="2" rounded
            style="height: 400px; overflow: auto">
            <v-textarea
              v-model="transcripcionTexto"
              label="Transcripción"
              variant="outlined"
              auto-grow
              rows="12"
              hide-details></v-textarea>
            <!-- <iframe v-if="contenidoArchivo" :src="contenidoArchivo" width="100%" height="100%" frameborder="0"></iframe> -->
            <div v-if="contenidoArchivo" class="d-flex justify-start ga-2">
              <v-btn class="mt-4" color="#005FA9" :loading="guardandoTranscripcion"
                @click.prevent="guardarTranscripcionEditada">
                Guardar cambios
              </v-btn>
              <v-btn class="mt-4" color="primary" @click.prevent="descargarArchivo">
                Descargar archivo
              </v-btn>
            </div>
          </v-sheet>



          <v-divider v-if="flagButton" class="my-4"></v-divider>
        </v-card-text>
      </v-card>
      <!-- Cards stepper 3-->
      <v-card v-if="step === 3" elevation="2" class="pa-4 mt-5">
        <v-card-text>
          <v-snackbar v-if="this.evidencia.model" v-model="showSnackbar" :color="snackbarColor" timeout="4000"
            location="top right" position="fixed">
            <v-icon left class="mr-2">mdi-alert-circle</v-icon>
            {{ snackbarMessage }}
          </v-snackbar>

          <!-- Knowledge Hub: se muestra despues de la transcripcion del audio.
               El switch permite elegir usarlo o continuar sin el. -->
          <template v-if="mostrarVistaModelo">
            <v-divider class="my-4"></v-divider>
            <!-- Selector Modelo IA / Knowledge Hub (RAG): disponible tanto para
                 audio como para documento/HU. -->
            <v-sheet
              class="pa-4 mb-6 mx-auto"
              rounded="lg"
              border
              max-width="520"
            >
              <div class="text-subtitle-1 font-weight-medium text-center mb-3">
                ¿Cómo quieres generar?
              </div>
              <div class="d-flex align-center justify-center ga-4">
                <span class="text-body-2" :class="useKnowledgeHub ? 'text-medium-emphasis' : 'font-weight-bold'
                  ">
                  Modelo IA
                </span>
                <v-switch v-model="useKnowledgeHub" color="#c1121f" hide-details inset density="compact"
                  class="flex-grow-0" @update:model-value="knowledgeHubDone = false"></v-switch>
                <span class="text-body-2 font-weight-bold" :style="useKnowledgeHub ? 'color:#c1121f' : 'opacity:.55'">
                  Knowledge Hub (RAG)
                </span>
              </div>
            </v-sheet>
            <v-sheet v-if="useKnowledgeHub" color="#c1121f" rounded
              class="pa-2 px-4 mb-3 text-white text-subtitle-1 font-weight-medium">
              Procesar Knowledge Hub
            </v-sheet>
            <KnowledgeHub v-if="useKnowledgeHub" :project-id="projectID" :description="projectDescripcion" @done="onKnowledgeHubDone"
              @error="onKnowledgeHubError"> </KnowledgeHub>
              

            <template v-else>
              <div class="mb-4">
                <v-sheet color="#194c9b" rounded class="pa-2 px-4 mb-3 text-white text-subtitle-1 font-weight-medium">
                  Procesar Transcripción Modelo IA
                </v-sheet>
                
                <div style="text-align: right; margin-top: 8px">
                  <v-btn color="primary" @click.prevent="obtainModelIA">
                    Procesar Transcripcion Modelo
                  </v-btn>
                </div>
              </div>
            </template>

            <!-- RESULTADOS (Casos/Historias): para Modelo IA y Knowledge Hub -->
            <div class="mb-4">
                <v-tabs v-model="tab" bg-color="transparent" color="primary" class="px-2" align-tabs="center">
                  <!-- TAB para poder elegir opciones  Casos de Prueba-->
                  <v-tab value="casosprueba">
                    <v-icon start>mdi-flask-outline</v-icon>
                    Casos de Prueba
                  </v-tab>
                  <v-tab value="historiausuario">
                    <v-icon start>mdi-account-details-outline</v-icon>
                    Historia de Usuario
                  </v-tab>
                </v-tabs>
                <v-divider />

                <v-window v-model="tab">
                  <!-- ========================= TAB 1: Casos de prueba ========================= -->
                  <v-window-item value="casosprueba">
                    <v-row class="mt-2" dense align="stretch">
                      <!-- IZQUIERDA -->
                      <v-col cols="12" md="6" class="d-flex">
                        <v-card variant="outlined" rounded="lg" class="panel-card d-flex flex-column w-100"
                          style="height: 500px">
                          <!-- HEADER -->
                          <div class="panel-header d-flex align-center justify-space-between">
                            <div>
                              <div class="text-subtitle-2 font-weight-medium">
                                Casos de prueba
                              </div>
                              <div class="text-caption text-medium-emphasis">
                                Seleccionados: {{ selectedCaseIds.length }}
                              </div>
                            </div>

                            <div class="d-flex align-center ga-2">
                              <v-btn
                                class="text-none"
                                :variant="todosCasosSeleccionados ? 'flat' : 'outlined'"
                                :color="todosCasosSeleccionados ? 'red' : 'primary'"
                                size="small"
                                :prepend-icon="todosCasosSeleccionados ? 'mdi-checkbox-multiple-marked' : 'mdi-checkbox-multiple-blank-outline'"
                                :disabled="testCases.length === 0"
                                @click="toggleSelectAllCases">
                                {{ todosCasosSeleccionados ? "Quitar todo" : "Seleccionar todo" }}
                              </v-btn>
                              <v-btn class="text-none" variant="tonal" size="small" prepend-icon="mdi-export"
                                :disabled="selectedCaseIds.length === 0" @click="exportSelectedToExcel">
                                Exportar seleccionados
                              </v-btn>
                            </div>
                          </div>

                          <v-divider />

                          <!-- BODY (scroll SOLO si hay > 5 casos) -->
                          <div class="panel-body flex-grow-1">
                            <v-card v-for="tc in testCases" :key="tc.id" variant="outlined" rounded="xl"
                              class="mb-2 case-card case-card--compact" :class="{
                                'case-card--selected': selectedCaseIds.includes(
                                  tc.id,
                                ),
                              }">
                              <v-card-text class="case-body">
                                <v-checkbox class="case-check" color="primary" density="compact" hide-details
                                  v-model="selectedCaseIds" :value="tc.id" />

                                <!-- TOP -->
                                <div class="d-flex align-start justify-space-between ga-3">
                                  <div class="flex-grow-1 pr-6">
                                    <div class="case-title-row">
                                      <v-icon class="case-ico" size="18" color="primary">
                                        mdi-clipboard-text-outline
                                      </v-icon>
                                      <div class="case-title">{{ tc.title }}</div>
                                    </div>

                                    <div class="case-desc text-caption text-medium-emphasis">
                                      {{ tc.description }}
                                    </div>
                                  </div>

                                  <v-chip v-if="tc.saved" size="x-small" variant="outlined" color="success"
                                    class="case-chip">
                                    <v-icon start size="14">mdi-check</v-icon>
                                    Guardado
                                  </v-chip>
                                </div>

                                <v-divider class="my-2" />

                                <!-- ACTIONS -->
                                <div class="d-flex justify-end ga-2">
                                  <v-tooltip text="Guardar">
                                    <template #activator="{ props }">
                                      <v-btn v-bind="props" icon size="small" variant="tonal" color="success"
                                        @click.stop="markAsSaved(tc.id)">
                                        <v-icon>mdi-content-save</v-icon>
                                      </v-btn>
                                    </template>
                                  </v-tooltip>

                                  <v-tooltip text="Exportar">
                                    <template #activator="{ props }">
                                      <v-btn v-bind="props" icon size="small" variant="outlined"
                                        @click.stop="exportOneToExcel(tc)">
                                        <v-icon>mdi-file-excel</v-icon>
                                      </v-btn>
                                    </template>
                                  </v-tooltip>

                                  <v-tooltip text="Detalle">
                                    <template #activator="{ props }">
                                      <v-btn v-bind="props" icon size="small" variant="outlined"
                                        @click.stop="openDetail(tc)">
                                        <v-icon>mdi-information-outline</v-icon>
                                      </v-btn>
                                    </template>
                                  </v-tooltip>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                          <!-- SELECCIONAR BOTON Casos de prueba -->
                          <div class="panel-footer d-flex justify-start">
                            <v-btn size="small" color="primary" variant="flat" rounded="lg"
                              prepend-icon="mdi-content-save" :disabled="selectedCaseIds.length === 0"
                              @click="saveSelectionToDb">
                              Seleccionar
                            </v-btn>
                          </div>
                        </v-card>
                      </v-col>

                      <v-col cols="12" md="6" class="d-flex">
                        <v-card variant="outlined" rounded="lg" class="panel-card d-flex flex-column w-100"
                          style="height: 500px">
                          <!-- HEADER -->
                          <div class="panel-header d-flex align-center justify-space-between">
                            <div>
                              <div class="text-subtitle-2 font-weight-medium">
                                Seleccionados
                              </div>
                              <div class="text-caption text-medium-emphasis">
                                {{ savedCases.length }} seleccionados
                              </div>
                            </div>
                          </div>

                          <v-divider />

                          <div class="panel-body flex-grow-1">
                            <!-- EMPTY -->
                            <div v-if="savedCases.length === 0" class="empty-selected">
                              <div class="empty-icon">
                                <v-icon size="40" color="grey">mdi-file-document-outline</v-icon>
                              </div>
                              <div class="text-caption text-medium-emphasis text-center">
                                Guarda casos (botón Guardar) para verlos aquí.
                              </div>
                            </div>

                            <!-- LIST -->
                            <v-card v-else v-for="tc in savedCases" :key="tc.id" variant="outlined" rounded="xl"
                              class="mb-2 case-card case-card--compact cool-card">
                              <v-card-text class="case-body case-body--right">
                                <v-btn icon size="small" variant="text" class="case-remove"
                                  @click="removeFromSaved(tc.id)">
                                  <v-icon size="20">mdi-close</v-icon>
                                </v-btn>

                                <div class="d-flex align-start justify-space-between ga-3">
                                  <div class="flex-grow-1 pr-6">
                                    <div class="case-title-row">
                                      <v-icon class="case-ico" size="18" color="primary">
                                        mdi-clipboard-text-outline
                                      </v-icon>
                                      <div class="case-title">{{ tc.title }}</div>
                                    </div>

                                    <div class="case-desc text-caption text-medium-emphasis">
                                      {{ tc.description }}
                                    </div>
                                  </div>

                                  <v-chip v-if="tc.saved" size="x-small" variant="outlined" color="success"
                                    class="case-chip">
                                    <v-icon start size="14">mdi-check</v-icon>
                                    Guardado
                                  </v-chip>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>

                          <!-- EXPORTACION de TESTCASES -->
                          <!-- FOOTER -->
                          <div class="panel-footer d-flex justify-end">
                            <v-btn size="small" color="primary" variant="flat" rounded="lg" prepend-icon="mdi-database"
                              :disabled="savedCases.length === 0" @click="saveTestCasesBD">
                              Guardar BD
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn padding-right="20%" size="small" color="primary" variant="flat" rounded="lg"
                              prepend-icon="mdi-jira" :disabled="savedCases.length === 0" @click="exportTestCases">
                              Exportar
                            </v-btn>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-window-item>
                  <!-- ========================= TAB 3: Historia de usuario ========================= -->
                  <v-window-item value="historiausuario">
                    <!-- Resumen del guion: arriba de las dos secciones -->
                    <div class="d-flex justify-center mt-2 mb-1">
                      <v-btn
                        class="text-none"
                        variant="tonal"
                        size="small"
                        color="#194c9b"
                        prepend-icon="mdi-script-text-outline"
                        :loading="guionCargando"
                        @click="verGuionResumen"
                      >
                        Trazabilidad y Preguntas.
                      </v-btn>
                    </div>
                    <v-row class="mt-2" dense align="stretch">
                      <!-- IZQUIERDA -->
                      <v-col cols="12" md="6" class="d-flex">
                        <v-card variant="outlined" rounded="lg" class="panel-card d-flex flex-column w-100"
                          style="height: 500px">
                          <div class="panel-header d-flex align-center justify-space-between">
                            <div>
                              <div class="text-subtitle-2 font-weight-medium">
                                Historias de usuario
                              </div>
                              <div class="text-caption text-medium-emphasis">
                                Seleccionadas: {{ selectedStoryIds.length }}
                              </div>
                            </div>
                            <div class="d-flex align-center ga-2">
                            <v-btn
                                class="text-none"
                                :variant="todasHistoriasSeleccionada ? 'flat' : 'outlined'"
                                :color="todasHistoriasSeleccionada ? 'red' : 'primary'"
                                size="small"
                                :prepend-icon="todasHistoriasSeleccionada ? 'mdi-checkbox-multiple-marked' : 'mdi-checkbox-multiple-blank-outline'"
                                :disabled="userStories.length === 0"
                                @click="toggleSelectAllHistory">
                                {{ todasHistoriasSeleccionada ? "Quitar todo" : "Seleccionar todo" }}
                              </v-btn>

                            <v-btn class="text-none" variant="tonal" size="small" prepend-icon="mdi-export"
                              :disabled="selectedStoryIds.length === 0" @click="exportSelectedStories">
                              Exportar seleccionados HU
                            </v-btn>
                            </div>
                          </div>

                          <v-divider />

                          <div class="panel-body flex-grow-1">
                            <v-card v-for="us in userStories" :key="us.id" variant="outlined" rounded="xl"
                              class="mb-2 case-card case-card--compact" :class="{
                                'case-card--selected': selectedStoryIds.includes(
                                  us.id,
                                ),
                              }">
                              <v-card-text class="case-body">
                                <v-checkbox class="case-check" color="primary" density="compact" hide-details
                                  v-model="selectedStoryIds" :value="us.id" />

                                <div class="d-flex align-start justify-space-between ga-3">
                                  <div class="flex-grow-1 pr-6">
                                    <div class="case-title-row">
                                      <v-icon class="case-ico" size="18" color="primary">
                                        mdi-file-document-outline
                                      </v-icon>
                                      <div class="case-title">{{ us.title }}</div>
                                    </div>

                                    <div class="case-desc text-caption text-medium-emphasis">
                                      {{ us.summary }}
                                    </div>
                                  </div>
                                </div>

                                <v-divider class="my-2" />

                                <div class="d-flex justify-end ga-2">
                                  <v-tooltip text="Guardar Historia">
                                    <template #activator="{ props }">
                                      <v-btn v-bind="props" icon size="small" variant="tonal" color="success"
                                        @click="markStoryAsSaved(us.id)">
                                        <v-icon>mdi-content-save</v-icon>
                                      </v-btn>
                                    </template>
                                  </v-tooltip>

                                  <v-tooltip text="Exportar HU">
                                    <template #activator="{ props }">
                                      <v-btn v-bind="props" icon size="small" variant="outlined"
                                        @click.stop="exportOneStory(us)">
                                        <v-icon>mdi-export</v-icon>
                                      </v-btn>
                                    </template>
                                  </v-tooltip>

                                  <v-tooltip text="Detalle">
                                    <template #activator="{ props }">
                                      <v-btn v-bind="props" icon size="small" variant="outlined"
                                        @click.stop="openStoryDetail(us)">
                                        <v-icon>mdi-information-outline</v-icon>
                                      </v-btn>
                                    </template>
                                  </v-tooltip>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>
                          <div class="panel-footer d-flex justify-start">
                            <v-btn size="small" color="primary" variant="flat" rounded="lg"
                              prepend-icon="mdi-content-save" :disabled="selectedStoryIds.length === 0"
                              @click="saveStoriesToDb">
                              Seleccionar
                            </v-btn>
                          </div>
                        </v-card>
                      </v-col>

                      <!-- DERECHA -->
                      <v-col cols="12" md="6" class="d-flex">
                        <v-card variant="outlined" rounded="lg" class="panel-card d-flex flex-column w-100"
                          style="height: 500px">
                          <div class="panel-header d-flex align-center justify-space-between">
                            <div>
                              <div class="text-subtitle-2 font-weight-medium">
                                Seleccionados
                              </div>
                              <div class="text-caption text-medium-emphasis">
                                {{ savedStories.length }} seleccionados
                              </div>
                            </div>
                          </div>

                          <v-divider />

                          <div class="panel-body flex-grow-1">
                            <div v-if="savedStories.length === 0" class="empty-selected">
                              <div class="empty-icon">
                                <v-icon size="40" color="grey">
                                  mdi-file-document-outline
                                </v-icon>
                              </div>
                              <div class="text-caption text-medium-emphasis text-center">
                                Guarda historias para verlas aquí.
                              </div>
                            </div>

                            <v-card v-else v-for="us in savedStories" :key="us.id" variant="outlined" rounded="xl"
                              class="mb-2 case-card case-card--compact">
                              <v-card-text class="case-body case-body--right">
                                <v-btn icon size="small" variant="text" class="case-remove"
                                  @click="removeStoryFromSaved(us.id)">
                                  <v-icon size="20">mdi-close</v-icon>
                                </v-btn>

                                <div class="d-flex align-start justify-space-between ga-3">
                                  <div class="flex-grow-1 pr-6">
                                    <div class="case-title-row">
                                      <v-icon class="case-ico" size="18" color="primary">
                                        mdi-file-document-outline
                                      </v-icon>
                                      <div class="case-title">{{ us.title }}</div>
                                    </div>

                                    <div class="case-desc text-caption text-medium-emphasis">
                                      {{ us.summary }}
                                    </div>
                                  </div>
                                </div>
                              </v-card-text>
                            </v-card>
                          </div>

                          <div class="panel-footer d-flex justify-end">
                            <v-btn size="small" color="primary" variant="flat" rounded="lg" prepend-icon="mdi-database"
                              :disabled="savedStories.length === 0" @click="saveBDFileHU">
                              Guardar BD
                            </v-btn>
                            <v-spacer></v-spacer>
                            <v-btn padding-right="20%" size="small" color="primary" variant="flat" rounded="lg"
                              prepend-icon="mdi-jira" :disabled="savedStoryIds.length === 0" @click="exportHistoryUser">
                              Exportar
                            </v-btn>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-window-item>
                </v-window>
                <v-divider class="my-4"></v-divider>
                <v-row justify="center" class="mb-2">
                  <v-col cols="auto"> </v-col>
                </v-row>
              </div>
          </template>
          <v-divider v-if="flagButton" class="my-4"></v-divider>

          <!-- Visor del archivo -->
          <!-- <v-sheet
            v-if="contenidoArchivo2"
            class="mt-4 pa-2"
            elevation="2"
            rounded
            style="height: 400px; overflow: auto"
          >
            <pre>{{ contenidoArchivo2 }}</pre>
            ).
            <iframe
              v-if="contenidoArchivo2"
              width="100%"
              height="100%"
              frameborder="0"
            ></iframe>
            <v-btn
              class="mt-4"
              color="primary"
              @click.prevent="descargarArchivo"
            >
              Descargar archivo
            </v-btn>
          </v-sheet> -->

          <!-- Artefactos del Knowledge Hub (Word/PDF/Excel): toggle mostrar/ocultar -->
          <div
            v-if="khArtifacts.length"
            class="d-flex justify-center my-4"
          >
            <v-btn
              :color="mostrarArtefactos ? 'grey-darken-1' : '#c1121f'"
              variant="tonal"
              class="text-none"
              :prepend-icon="mostrarArtefactos ? 'mdi-eye-off-outline' : 'mdi-file-download-outline'"
              :loading="cargandoArtefactos"
              @click="toggleArtefactos"
            >
              {{ mostrarArtefactos ? "Ocultar artefactos" : `Obtener artefactos (${khArtifacts.length})` }}
            </v-btn>
          </div>
          <KnowledgeArtifacts
            v-if="mostrarArtefactos && khArtifacts.length"
            :artifacts="khArtifacts"
            :job-id="khJobId"
            class="mt-2 mb-4"
          />

          <div class="d-flex justify-space-between align-center">
            <v-btn color="#005FA9" class="mt-3" @click.prevent="returnStep">
              Regresar</v-btn>
          </div>
          <v-divider v-if="flagButton" class="my-4"></v-divider>
        </v-card-text>
      </v-card>
      <TestCaseDetailDialog v-model="detailDialog" :test-case="detailCase" :projectName="$route.query.projectName || ''"
        @save="onSaveCase" />
      <UserStoryDetailDialog v-model="storyDetailDialog" :project-name="$route.query.projectName || ''"
        :user-story="storyDetailStory" @save="onSaveStory" />
      <HistoriaUsuarioExport v-model="exportHUDialog" :stories="exportHUStories"
        :project-name="$route.query.projectName || ''" />
    </v-container>

    <LoadingModel
      :visible="loading"
      :message="loadingMensaje"
      :progress="progresoLoading"
    />

    <!-- Visor del resumen del guion (Historias de Usuario) -->
    <v-dialog v-model="guionDialog" max-width="900">
      <v-card rounded="lg">
        <v-card-title
          class="d-flex align-center justify-space-between text-subtitle-1 font-weight-bold"
        >
          <span>Trazabilidad y Preguntas.</span>
          <v-btn icon variant="text" @click="guionDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <iframe
            v-if="guionEsUrl"
            :src="guionContenido"
            width="100%"
            height="500"
            frameborder="0"
          ></iframe>
          <pre
            v-else
            style="white-space: pre-wrap; margin: 0; max-height: 500px; overflow: auto"
          >{{ guionContenido }}</pre>
        </v-card-text>
        <v-divider />
        <v-card-actions class="justify-end">
          <v-btn
            v-if="guionEsUrl"
            variant="tonal"
            prepend-icon="mdi-download"
            @click="descargarGuion"
          >
            Abrir / Descargar
          </v-btn>
          <v-btn variant="text" @click="guionDialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main>
</template>
<script>
import "@/css/Global.css";
import "@/css/ModelIA/StylesModel.css";
import api from "@/api/axios/axios.js";
import LoadingModel from "@/components/Global/Loading.vue";
// import confetti from "canvas-confetti";
import { celebrar } from "@/utils/swal.js";
import TestCaseDetailDialog from "./TestCaseDetailDialog.vue";
import UserStoryDetailDialog from "./UserStoryDetailDialog.vue";
import KnowledgeHub from "./KnowledgeHub.vue";
import KnowledgeArtifacts from "./KnowledgeArtifacts.vue";
import HistoriaUsuarioExport from "./HistoriaUsuarioExport.vue";
import { getKnowledgeResult } from "@/api/KnowledgeService";
import { swal } from "@/utils/swal.js";
import { setIssueHistory, setIssueTestCases } from "@/api/jiraproyectos";
import {
  getAudio,
  getTrans,
  postHistory,
  getHistory,
  getTestCases,
  postTestCases,
  extraerTextoDocumento,
  getTextoHistoria,
  getGuionResumen,
  editarTranscripcion,
} from "@/api/dataPersist";
import { getProyectoDetail } from "@/api/proyectos";

import {
  exportMultipleCases,
  exportSingleCase,
} from "../../utils/Exceles/IAModelsExcel";
export default {
  name: "IAModel",
  components: {
    LoadingModel,
    TestCaseDetailDialog,
    UserStoryDetailDialog,
    KnowledgeHub,
    KnowledgeArtifacts,
    HistoriaUsuarioExport,
  },
  data() {
    return {
      descripcion: "hola",
      projectDescripcion: "",
      seleccion: "1",
      archivo: null,
      historiaTexto: "",
      historiaArchivo: null,
      modoHistoria: "texto",
      textoExtraido: "",
      procesado: false,
      audioUrl: null,
      flagButton: false,
      useKnowledgeHub: false,
      knowledgeHubDone: false,
      khArtifacts: [],
      khJobId: null,
      mostrarArtefactos: false,
      cargandoArtefactos: false,
      exportHUDialog: false,
      exportHUStories: [],
      maxDurationMinutes: 30,
      maxSizeMB: 500,
      //texto editable de la transcripcion (agregar mas datos)
      transcripcionTexto:"",
      // Loading del boton "Guardar cambios" de la transcripcion editada.
      guardandoTranscripcion: false,
      // Progreso de la transcripcion (para el loading)
      transProgreso: null,
      transCola: null,
      // Progreso del modelo IA (casos/historias)
      modelProgreso: null,
      modelEtapa: "",
      // Visor del resumen del guion (Historias de Usuario)
      guionDialog: false,
      guionCargando: false,
      guionContenido: "",
      guionEsUrl: false,
      step: 1,
      namefile: "",
      detailDialog: false,
      detailCase: null,
      tipoArchivo: "audio",
      loading: false,
      detailProjectName: null,
      snackbarMessage: "",
      showSnackbar: false,
      snackbarColor: "",
      audionot: null,
      contenidoArchivo: null,
      val: "",
      contenidoArchivo2: null,
      items: [
        { label: this.$t("carga1"), value: "audio" },
        // { label: this.$t("Texto"), value: "texto" },
        { label: this.$t("his_user"), value: "historia_usuario" },
      ],
      tab: "casosprueba",
      savedCaseIds: [],
      testCases: [

      ],
      selectedCaseIds: [],
      userStories: [],

      selectedStoryIds: [],
      savedStoryIds: [],
      savedTestCasesIds: [],
      storyDetailDialog: false,
      storyDetailStory: null,
      // nuevos datos persistencia
      projectID: null,
      evidencia: {
        video_url: null,
        audio_url: null,
        documento: null,
        tipo_transcripcion: null,
        transcripcion: null,
        model: null,
      },
    };
  },
  async mounted() {
    this.loading = true;
    try {
      await this.getProyect();
      await Promise.all([
        this.getVideo(),
        this.getTranscripcion(),
        this.getHistory(),
        this.getTestCasess(), // error en esto para casos de prueba
        this.getTextoHistoria(),
      ]);
    } catch (error) {
      console.log("Error cargando datos de persistencia", error);
    } finally {
      this.loading = false;
    }
  },

  computed: {
    selectedStories() {
      if (!Array.isArray(this.userStories)) return [];
      return this.userStories.filter((us) =>
        this.selectedStoryIds.includes(us.id),
      );
    },

    selectedCases() {
      return this.testCases.filter((tc) =>
        this.selectedCaseIds.includes(tc.id),
      );
    },

    // Nombre del archivo seleccionado en "Cargar archivo" (File o arreglo)
    nombreHistoriaArchivo() {
      const f = Array.isArray(this.historiaArchivo)
        ? this.historiaArchivo[0]
        : this.historiaArchivo;
      return f?.name || "";
    },
    transcripcionEsDelAudio() {
      return this.evidencia.tipo_transcripcion === "audio";
    },

    // El texto guardado corresponde al DOCUMENTO/historia (no al audio).
    textoEsDeDocumento() {
      return this.evidencia.tipo_transcripcion === "documento";
    },

    // Mensaje del loading: muestra progreso/cola de la transcripcion si aplica.
    loadingMensaje() {
      if (this.transCola != null) {
        return `En cola… posición ${this.transCola}`;
      }
      if (this.transProgreso != null) {
        return "Transcribiendo…"; // el % lo muestra la barra
      }
      // Modelo IA (casos/historias): la etapa viene del backend.
      if (this.modelEtapa) {
        return this.modelEtapa; // ej "Generando casos de prueba (4/7)"
      }
      if (this.modelProgreso != null) {
        return "Generando…";
      }
      return null; // LoadingModel usa su texto por defecto
    },
    // Progreso 0-100 para la barra (transcripcion o modelo).
    progresoLoading() {
      return this.transProgreso ?? this.modelProgreso;
    },
    // Muestra la vista del modelo (switch/boton + resultados) cuando hay
    // insumo listo, ya sea por AUDIO (transcripcion) o por DOCUMENTO/HU (texto).
    mostrarVistaModelo() {
      const audioListo = !!(
        this.contenidoArchivo && this.transcripcionEsDelAudio
      );
      const docListo =
        this.textoEsDeDocumento &&
        !!(this.textoExtraido && this.textoExtraido.trim());
      return audioListo || docListo;
    },

    // Habilita el "Siguiente" del paso 1 segun la fuente seleccionada.
    //  - historia: requiere texto obtenido y que sea del documento.
    //  - audio/video: requiere audio obtenido o persistido.
    puedeAvanzarPaso1() {
      if (this.tipoArchivo === "historia_usuario") {
        return (
          !!(this.textoExtraido && this.textoExtraido.trim()) &&
          this.textoEsDeDocumento
        );
      }
      return !!(this.audioUrl || this.evidencia.audio_url);
    },

    // True si TODOS los casos estan seleccionados (para el boton de select-all).
    todosCasosSeleccionados() {
      return (
        this.testCases.length > 0 &&
        this.selectedCaseIds.length === this.testCases.length
      );
    },
    todasHistoriasSeleccionada(){
return (
  this.userStories.length >0 &&
  this.selectedStoryIds.length === this.userStories.length
)
    },
    savedCases() {
      return this.testCases.filter((tc) => this.savedCaseIds.includes(tc.id));
    },
    savedStories() {
      if (!Array.isArray(this.userStories)) return [];
      const ids = Array.isArray(this.savedStoryIds) ? this.savedStoryIds : [];
      return this.userStories.filter((us) => ids.includes(us.id));
    },
    selectedStoryCount() {
      return this.selectedStoryIds.length || 0;
    },
    tituloCargaHeader() {
      return this.tipoArchivo === this.$t("carga1")
        ? this.$t("carga1")
        : this.tipoArchivo === this.$t("Texto")
          ? this.$t("Texto")
          : this.$t("step_carga2_HU");
    },
  },
  methods: {
    validateMedia(value) {
      const file = Array.isArray(value) ? value[0] : value;

      if (!file) return true;

      const allowedTypes = [
        "video/mp4",
        "video/quicktime",
        "video/webm",
        "audio/mpeg",
        "audio/wav",
        "audio/x-wav",
        "audio/mp4",
        "audio/x-m4a",
        "audio/m4a",
      ];

      const allowedExtensions = [
        ".mp4",
        ".mov",
        ".webm",
        ".mp3",
        ".wav",
        ".m4a",
      ];
      const fileName = file.name?.toLowerCase() || "";

      const isAllowedType = allowedTypes.includes(file.type);
      const isAllowedExtension = allowedExtensions.some((ext) =>
        fileName.endsWith(ext),
      );

      if (!isAllowedType && !isAllowedExtension) {
        return this.$t("media_invalid_type");
      }

      const maxBytes = this.maxSizeMB * 1024 * 1024;

      if (file.size > maxBytes) {
        return this.$t("media_max_size", { size: this.maxSizeMB });
      }

      return true;
    },

    async validateMediaDuration(value) {
      const file = Array.isArray(value) ? value[0] : value;

      if (!file || !(file instanceof File)) return;

      const isValid = this.validateMedia(file);

      if (isValid !== true) {
        this.archivo = null;

        await swal({
          icon: "warning",
          title: this.$t("media_invalid_file"),
          text: isValid,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });

        return;
      }

      const url = URL.createObjectURL(file);

      const media = file.type.startsWith("audio")
        ? document.createElement("audio")
        : document.createElement("video");

      media.preload = "metadata";

      media.onloadedmetadata = async () => {
        URL.revokeObjectURL(url);

        const durationMinutes = media.duration / 60;

        if (durationMinutes > this.maxDurationMinutes) {
          this.archivo = null;

          await swal({
            icon: "warning",
            title: this.$t("media_too_long"),
            text: this.$t("media_max_duration", {
              minutes: this.maxDurationMinutes,
            }),
            customClass: {
              popup: this.isDark ? "mi-popup" : "mi-popup-2",
              title: "mi-titulo",
            },
          });
        }
      };

      media.onerror = async () => {
        URL.revokeObjectURL(url);
        this.archivo = null;

        await swal({
          icon: "error",
          title: this.$t("media_read_error_title"),
          text: this.$t("media_read_error_text"),
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      };

      media.src = url;
    },
    generarTexto(historias) {
      return historias.map((hu) => {
        return `

        ${hu.storyText}
        `;
      });
    },
    generarTextoTestCases(testCase) {
      console.log("909", testCase)
      return testCase.map((tc) => {
        console.log(tc.title)
        console.log(tc.description)
        console.log(tc.steps)
        var stepsText = this.generateFormatSaveBDTestCases(tc.steps)
        return `Caso de prueba:${tc.title}

            ${tc.description}
              Tabla de pasos:
              | Step | Resultado esperado |
              | --- | --- |
            ${stepsText}
            `;
      });
    },
    onSaveCase(updatedCase) {
      this.detailCase = updatedCase;
      const idx = this.testCases.findIndex((tc) => tc.id === updatedCase.id);
      if (idx !== -1) this.testCases.splice(idx, 1, updatedCase);
    },
    onSaveStory(updatedStory) {
      // 1) actualiza el objeto abierto en el modal
      this.storyDetailStory = { ...updatedStory };

      // 2) usa EL ARRAY REAL (cambia userStories por el modificado)
      const list = this.userStories; // <-- AJUSTA ESTE NOMBRE

      // guarda para que no truene
      if (!Array.isArray(list)) {
        console.warn("userStories no es un array todavía:", list);
        return;
      }

      const i = list.findIndex((s) => s.id === updatedStory.id);
      if (i === -1) return;

      // 3) reemplazo reactivo (clave para que se refleje)
      list.splice(i, 1, {
        ...list[i],
        title: updatedStory.title,
        storyText: updatedStory.storyText,
      });
    },
    // Convierte una URL absoluta del backend (http://localhost:8005/media/...)
    // en ruta absoluta del mismo host (/media/...), para que nginx la proxee.
    // Selecciona / deselecciona TODOS los casos de prueba.
    toggleSelectAllCases() {
      if (this.selectedCaseIds.length === this.testCases.length) {
        this.selectedCaseIds = [];
      } else {
        this.selectedCaseIds = this.testCases.map((tc) => tc.id);
      }
    },
    toggleSelectAllHistory() {
      if (this.selectedStoryIds.length === this.userStories.length) {
        this.selectedStoryIds = [];
      } else {
        this.selectedStoryIds = this.userStories.map((tc) => tc.id);
      }
    },
    // Nombre de archivo legible: toma el ultimo segmento y lo decodifica
    // (evita ver %20, %C3%B1, etc.).
    nombreArchivo(url) {
      if (!url) return "";
      const base = url.split("/").pop();
      try {
        return decodeURIComponent(base);
      } catch (e) {
        return base;
      }
    },
    toRelativeUrl(url) {
      if (!url) return url;
      try {
        const u = new URL(url, window.location.origin);
        return u.pathname + u.search;
      } catch {
        return url; // ya era relativa
      }
    },
    async getVideo() {
      console.log(this.projectID);
      var res = await getAudio(this.projectID);
      console.log("ES8", res.video_url)

      this.evidencia.video_url = this.toRelativeUrl(res.video_url);
      this.evidencia.documento = this.toRelativeUrl(res.documento);
      this.evidencia.tipo_transcripcion = res.tipo_transcripcion;
      this.evidencia.audio_url = this.toRelativeUrl(res.audio_url);
      console.log("RRR", res);
      if (this.evidencia.audio_url && this.evidencia.video_url) {
        this.flagButton = true;
        this.audioUrl = this.evidencia.audio_url;
      }
    },
    async getTranscripcion() {
      var res = await getTrans(this.projectID);
      console.log("TRanscripcion ", res);
      if (res.error == "No Existe transcripcion") {
        this.contenidoArchivo = null;
        this.transcripcionTexto="";
      } else {
        //const blob = new Blob([res], { type: "text/plain" });
        this.transcripcionTexto = typeof res === "string" ? res : String(res ?? "");
        const blob = new Blob([this.transcripcionTexto], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        this.contenidoArchivo = url;
      }
    },
    // Guarda en BD el texto editado de la transcripcion (POST .../editar/).
    async guardarTranscripcionEditada() {
      const texto = (this.transcripcionTexto || "").trim();
      if (!texto) {
        this.snackbarMessage = "La transcripción está vacía";
        this.showSnackbar = true;
        this.snackbarColor = "error";
        return;
      }
      try {
        this.guardandoTranscripcion = true;
        const payload = await this.getProyect();
        const res = await editarTranscripcion(payload.project, texto);

        // El backend puede avisar que no hubo cambios o que invalidó el guion.
        if (res?.sin_cambios) {
          this.snackbarMessage = "No hubo cambios en la transcripción";
          this.snackbarColor = "info";
        } else {
          this.snackbarMessage = res?.guion_invalidado
            ? "Transcripción guardada. El guion se regenerará en la próxima generación."
            : res?.message || "Transcripción actualizada";
          this.snackbarColor = "success";
        }
        this.showSnackbar = true;
      } catch (error) {
        console.error(error);
        this.snackbarMessage =
          error?.response?.data?.error ||
          error?.response?.data?.detail ||
          "No se pudo guardar la transcripción";
        this.showSnackbar = true;
        this.snackbarColor = "error";
      } finally {
        this.guardandoTranscripcion = false;
      }
    },
    async getHistory() {
      var res = await getHistory(this.projectID);
      if (res.data.length > 0) {
        this.getDataHistory(res.data);
      }
    },
    // Carga el texto base guardado en BD para mostrarlo en el preview.
    // No se vuelca en el textarea de "Escribe tu historia de usuario".
    // Trae el resumen del guion y lo muestra. Tolera respuesta como URL,
    // texto plano u objeto ({ url } / { resumen } / { texto } / { text }).
    async verGuionResumen() {
      this.guionCargando = true;
      try {
        const res = await getGuionResumen(this.projectID);
        console.log("Guion resumen →", res);
        let val = res;
        if (res && typeof res === "object") {
          val =
            res.url ??
            res.archivo ??
            res.resumen ??
            res.texto ??
            res.text ??
            JSON.stringify(res, null, 2);
        }
        val = String(val ?? "");
        this.guionEsUrl = /^(https?:\/\/|\/media\/|\/)/.test(val.trim());
        this.guionContenido = this.guionEsUrl ? this.toRelativeUrl(val) : val;
        this.guionDialog = true;
      } catch (e) {
        console.error(e);
        this.snackbarMessage = "No se pudo obtener el resumen del guion";
        this.showSnackbar = true;
        this.snackbarColor = "error";
      } finally {
        this.guionCargando = false;
      }
    },
    descargarGuion() {
      if (this.guionContenido) {
        window.open(this.guionContenido, "_blank");
      }
    },
    async getTextoHistoria() {
      const data = await getTextoHistoria(this.projectID);
      if (data.texto) {
        const limpio = (data.texto || "").toString().trim();
        if (limpio) {
          this.textoExtraido = limpio;
          this.namefile = data.name
        }
      } else {
        console.log("Nada")
      }

    },
    async getTestCasess() {
      var res = await getTestCases(this.projectID);
      if (res.data.length > 0) {
        console.log("Si hay Casos");
        this.getDataTestCases(res.data);
      }
    },
    async getProyect() {
      const projectName = this.$route.query.projectName;

      const project = await getProyectoDetail(projectName);
      // console.log("EEEE 22222", res)
      // const project = useProjectStore();
      // project.setProject(res)
      console.log("EEEE ", project.idProyect);
      const payload = {
        project: project.idProyect,
        descripcion: project.description,
      };

      this.projectID = project.idProyect;
      // Guardamos la descripcion del proyecto para pasarla al Knowledge Hub.
      this.projectDescripcion = project.description ?? "";
      console.log("EESSS", this.projectID);
      return payload;
      //ESTO ES PARA LAS HISTORIAS DE USUARIO
      //   const resp=await setIssueHistory(payload)
      //  //console.log("Respuesta ", resp)
    },
    onToggleStorySelection(id, val) {
      if (val) {
        if (!this.selectedStoryIds.includes(id)) this.selectedStoryIds.push(id);
      } else {
        this.selectedStoryIds = this.selectedStoryIds.filter((x) => x !== id);
      }
    },

    removeStoryFromSelection(id) {
      this.selectedStoryIds = this.selectedStoryIds.filter((x) => x !== id);
    },

    markStoryAsSaved(id) {
      if (!this.savedStoryIds.includes(id)) {
        this.savedStoryIds.push(id);
      }
      //console.log("DDD", this.savedStoryIds);
    },

    removeStoryFromSaved(id) {
      this.savedStoryIds = this.savedStoryIds.filter((x) => x !== id);
    },

    openStoryDetail(us) {
      if (!us) return;
      this.storyDetailStory = us;
      this.storyDetailDialog = true;
    },

    exportOneStory(us) {
      if (!us) return;
      // Abre el dialogo de formato (plantilla + PDF/Word) con una sola historia.
      this.exportHUStories = [us];
      this.exportHUDialog = true;
    },

    exportSelectedStories() {
      if (!this.selectedStories.length) return;
      // Abre el dialogo de formato con las historias seleccionadas.
      this.exportHUStories = [...this.selectedStories];
      this.exportHUDialog = true;
    },

    saveStoriesToDb() {
      //console.log("Guardar historias:", this.selectedStories);
      this.savedStoryIds = [
        ...new Set([...this.savedStoryIds, ...this.selectedStoryIds]),
      ];
    },
    async saveTestCasesBD() {
      try {
        const savedTest = this.testCases.filter((us) =>
          this.savedCaseIds.includes(us.id),
        );
        const text = this.generarTextoTestCases(savedTest);
        await postTestCases(this.projectID, text);
        await swal({
          icon: "success",
          title: "Guardar en Base de Datos",
          text: `Se ha guardado satisfactoriamente en BD`,
          timer: 2500,

          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    async saveBDFileHU() {
      try {
        const savedStories = this.userStories.filter((us) =>
          this.savedStoryIds.includes(us.id),
        );
        const texto = this.generarTexto(savedStories);
        console.log("EEE", texto)
        await postHistory(this.projectID, texto);

        await swal({
          icon: "success",
          title: "Guardar en Base de Datos",
          text: `Se ha guardado satisfactoriamente en BD`,
          timer: 2500,

          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } catch (error) {
        await swal({
          icon: "error",
          title: "Error",
          text: "Hubo un error al guardar en la Base de Datos",
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      }
      // console.log("Guardar",texto)
    },

    // Casos de Prueba
    async exportTestCases() {
      const savedTest = this.testCases.filter((tc) =>
        this.savedCaseIds.includes(tc.id),
      );
      try {
        this.loading = true;
        for (const test of savedTest) {
          const projectName = this.$route.query.projectName;

          const project = await getProyectoDetail(projectName);
          // const project = useProjectStore();
          const payload = {
            project: project.idProyect,
            descripcion: test.description,
            title: test.title,
            steps: test.steps,
          };
          const resp = await setIssueTestCases(payload);
          if (resp.status == 400) {
            this.loading = false;
            await swal({
              icon: "error",
              title: "Error",
              text: resp.error,
              customClass: {
                popup: this.isDark ? "mi-popup" : "mi-popup-2",
                title: "mi-titulo",
              },
            });
          }
        }
        this.loading = false;
        await swal({
          icon: "success",
          title: "Exportacion a Jira",
          text: `Exportacion con exito de Casos de Prueba`,
          timer: 2500,

          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } catch (error) {
        this.loading = false;
        await swal({
          icon: "error",
          title: "Error",
          text: error,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } finally {
        this.loading = false;
      }
    },
    //EXPORTAR
    async exportHistoryUser() {
      const savedStories = this.userStories.filter((us) =>
        this.savedStoryIds.includes(us.id),
      );
      try {
        this.loading = true;
        for (const story of savedStories) {
          const projectName = this.$route.query.projectName;

          const project = await getProyectoDetail(projectName);
          //const project = useProjectStore();
          const payload = {
            project: project.idProyect,
            descripcion: story.storyText,
            title: story.title,
          };

          // ESTO ES PARA LAS HISTORIAS DE USUARIO
          const resp = await setIssueHistory(payload);
          this.loading = false;
          if (resp.status == 400) {
            await swal({
              icon: "error",
              title: "Error",
              text: resp.error,
              customClass: {
                popup: this.isDark ? "mi-popup" : "mi-popup-2",
                title: "mi-titulo",
              },
            });
          } else {
            await swal({
              icon: "success",
              title: "Exportacion a Jira",
              text: `Se exportacion con exito`,
              timer: 2500,

              showConfirmButton: false,
              customClass: {
                popup: this.isDark ? "mi-popup" : "mi-popup-2",
                title: "mi-titulo",
              },
            });
          }
        }
      } catch (error) {
        this.loading = false;
        await swal({
          icon: "error",
          title: "Error",
          text: error,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        });
      } finally {
        this.loading = false;
      }
    },

    clearStorySelection() {
      this.selectedStoryIds = [];
    },

    downloadTxt(filename, content) {
      const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },

    projectName() {
      return this.$route.query.projectName || "";
    },

    openDetail(tc) {
      this.detailCase = tc;
      this.detailProjectName = this.projectName();
      this.detailDialog = true;
    },

    markAsSaved(id) {
      if (!this.savedCaseIds.includes(id)) this.savedCaseIds.push(id);
    },

    removeFromSaved(id) {
      this.savedCaseIds = this.savedCaseIds.filter((x) => x !== id);
    },

    async exportOneToExcel(tc) {
      console.log("Obtencion de Caso de Excel Simple", tc)
      await exportSingleCase(tc, this.$route.query.projectName);
    },

    async exportSelectedToExcel() {
      const selectedCases = this.testCases.filter((tc) =>
        this.selectedCaseIds.includes(tc.id),
      );

      await exportMultipleCases(selectedCases, this.$route.query.projectName);
    },

    saveSelectionToDb() {
      //console.log("Guardar en BD (checkbox):", this.selectedCases);
      this.savedCaseIds = [
        ...new Set([...this.savedCaseIds, ...this.selectedCaseIds]),
      ];
    },
    async mostrarConfeti() {
      await celebrar({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
      });
    },
    setStep() {
      // En historia de usuario el paso 2 (transcripcion) es solo para audio,
      // por eso saltamos directo al paso 3 (modelo).
      if (this.tipoArchivo === "historia_usuario") {
        this.step = 3;
        this.flagButton = true;
        return;
      }
      this.step = this.step + 1;
      if (this.contenidoArchivo && this.contenidoArchivo != null) {
        this.flagButton = true;
      } else {
        this.flagButton = false;
      }
    },
    returnStep() {
      if (this.tipoArchivo === "historia_usuario" && this.step === 3) {
        this.step = 1;
        this.flagButton = true;
        return;
      }
      this.step = this.step - 1;
      if (this.evidencia.audio_url || this.audioUrl) {
        this.flagButton = true;
      }
    },

    returnProyects() {
      this.$router.push({ name: "GeneracionProyecto" });
    },

    getStepClass(n) {
      if (this.step === n) return "step-active";
      if (this.step > n) return "step-complete";
      return "step-pending";
    },
    onCambiarModoHistoria(modo) {
      // Al cambiar de modo limpiamos el input que no se va a usar
      if (modo === "texto") {
        this.historiaArchivo = null;
      } else {
        this.historiaTexto = "";
      }
      // Reiniciamos el texto obtenido para evitar mezclar resultados

    },
    // Obtiene el texto de la historia de usuario: del texto escrito o
    // extrayendolo del documento (.txt, .docx, .pdf) en el backend.
    async obtenerTextoHistoria() {
      try {
        this.procesando = true;
        this.loading = true
        const payload = await this.getProyect();
        let archivo;
        if (this.modoHistoria === "archivo") {
          if (!this.historiaArchivo) return;
          archivo = this.historiaArchivo;
        } else {
          const texto = (this.historiaTexto || "").trim();
          if (!texto) return;
          archivo = new File(
            [texto],
            `historia_usuario_${payload.project}.txt`,
            { type: "text/plain" },
          );
        }
        const texto = await extraerTextoDocumento(payload.project, archivo)
        this.textoExtraido = (texto || "").toString();
        console.log("RRRR", texto)
        if (!this.textoExtraido || !this.textoExtraido.trim()) {
          this.snackbarMessage = "No se obtuvo texto del documento";
          this.showSnackbar = true;
          this.snackbarColor = "error";
          return;
        }

        this.flagButton = true;
        // Acabamos de procesar el documento: el texto actual es del documento.
        this.evidencia.tipo_transcripcion = "documento";
        await this.mostrarConfeti();
        this.getTextoHistoria()
        this.snackbarMessage = "Texto obtenido correctamente";
        this.showSnackbar = true;
        this.snackbarColor = "success";
      } catch (error) {
        console.error(error);
        this.snackbarMessage =
          "Hubo un error al obtener el texto del documento";
        this.showSnackbar = true;
        this.snackbarColor = "error";
      } finally {
        this.procesando = false;
        this.loading = false;
      }
    },
    async procesarVideo() {
      if (!this.archivo) return;

      try {
        const payload = await this.getProyect();
        this.procesando = true;
        this.loading = true;
        const formData = new FormData();
        console.log("WWES ", this.archivo)
        if (this.archivo.name.includes(".mp3")) {
          formData.append("audio", this.archivo);
          formData.append("Descripcion", this.archivo.name);
          formData.append("Proyecto", payload.project);
        } else {

          formData.append("video", this.archivo);
          formData.append("Descripcion", this.archivo.name);
          formData.append("Proyecto", payload.project);
        }
        const response = await api.post(
          "/login/modelIATestCases/",
          formData,
          {
            // headers: {
            //   "Content-Type": "miltipart/form-data",
            // },
            responseType: "blob",
          },
        );
        this.loading = false;
        //console.log("biiiiii");
        const audioBlob = response.data;

        this.audioUrl = URL.createObjectURL(audioBlob);
        this.flagButton = true;

        // const audio = new Audio(audioUrl);
        // audio.controls = true;
        // document.body.appendChild(audio);
        // audio.play();
        //console.log(response);
        await this.mostrarConfeti();
        await this.getVideo();
        this.snackbarMessage = this.$t("audioSuccess");
        this.showSnackbar = true;
        this.snackbarColor = "success";
      } catch (err) {
        this.audionot = true;
        this.loading = false;
        this.snackbarMessage =
          "Hubo un error en la obtencion del audio del archivo";
        this.showSnackbar = true;
        this.snackbarColor = "error";
        //console.log("error al transcribir el archivo de video", err);
      }
    },
    async downloadFile() {
      try {
        const payload = await this.getProyect();
        this.loading = true;

        // 1) Encolar la transcripcion: responde al instante con un task_id
        //    (asincrono, para no colgar la peticion 10+ min → no mas 504).
        const startResp = await api.post("/login/transcripcion/encolar/", {
          proyecto: payload.project,
        });
        const taskId = startResp.data?.task_id ?? startResp.data?.id;
        const proyectoId = startResp.data?.proyecto_id ?? payload.project;
        if (!taskId) {
          throw new Error("El servidor no devolvio un task_id de transcripcion");
        }

        // 2) Polling del estado hasta terminar. En "done" el texto viene en
        //    `texto` (OJO: no `text`).
        const done = await this.pollTranscripcion(proyectoId, taskId);
        // Ya termino: limpiamos progreso/cola para el loading.
        this.transCola = null;
        this.transProgreso = null;

        // 3) Usamos el texto del "done" directamente; si no viniera, caemos a
        //    getTranscripcion (transcripcion persistida).
        const textoTrans = done?.texto ?? "";
        if (textoTrans) {
          this.transcripcionTexto = textoTrans; // Editable en el textarea
          const blob = new Blob([textoTrans], { type: "text/plain" });
          this.contenidoArchivo = URL.createObjectURL(blob);
        } else {
          await this.getTranscripcion();
        }

        this.flagButton = true;
        // Acabamos de transcribir el audio: la transcripcion ya es del audio.
        this.evidencia.tipo_transcripcion = "audio";
        this.loading = false;

        await this.mostrarConfeti();

        this.snackbarMessage = "El Archivo fue trancrito correctamente";
        this.showSnackbar = true;
        this.snackbarColor = "success";
      } catch (error) {
        console.error(error);
        this.loading = false;
        this.transCola = null;
        this.transProgreso = null;
        // Mostramos el error real del backend si viene (ej. fallo al encolar
        // en el microservicio), y si no, un mensaje generico.
        this.snackbarMessage =
          error?.response?.data?.error ||
          error?.response?.data?.detail ||
          "Hubo un error en la transcripción del audio del archivo";
        this.showSnackbar = true;
        this.snackbarColor = "error";
      }
    },
    // Polling del estado de la transcripcion asincrona.
    async pollTranscripcion(
      proyectoId,
      taskId,
      { interval = 3000, maxWaitMs = 7200000 } = {},
    ) {
      const startedAt = Date.now();
      // eslint-disable-next-line no-constant-condition
      while (true) {
        if (Date.now() - startedAt > maxWaitMs) {
          throw new Error("La transcripcion excedio el tiempo de espera");
        }
        const resp = await api.get(
          `/login/transcripcion/estado/${proyectoId}/${taskId}/`,
        );
        const data = resp.data || {};
        const estado = String(data.status ?? data.estado ?? data.state ?? "")
          .toLowerCase();
        console.log("Transcripcion estado →", data);

        if (["done", "success", "completado", "finished", "ok"].includes(estado)) {
          return data;
        }
        if (["error", "failure", "failed", "fallido"].includes(estado)) {
          throw new Error(data.error || "Error en la transcripcion");
        }
        // Progreso / posicion en cola (solo existen en pending/processing).
        if (estado === "pending") {
          this.transCola = data.queue_position ?? null;
          this.transProgreso = null;
        } else if (estado === "processing") {
          this.transProgreso = data.progress ?? null;
          this.transCola = null;
        }
        // processing / pending / started: esperar y reintentar.
        await new Promise((resolve) => setTimeout(resolve, interval));
      }
    },
    onKnowledgeHubDone(result) {
      // El Knowledge Hub termino: habilitamos el boton "Siguiente".
      this.knowledgeHubDone = true;

      // test_cases / user_stories vienen en el MISMO formato que el modelo IA,
      // asi que reutilizamos los mismos parsers y la vista del paso 3.
      if (Array.isArray(result?.test_cases) && result.test_cases.length) {
        this.getDataTestCases(result.test_cases);
      }
      if (Array.isArray(result?.user_stories) && result.user_stories.length) {
        this.getDataHistory(result.user_stories);
      }

      // Artefactos (Word/PDF/Excel): se guardan, pero se muestran solo si el
      // usuario los pide con el boton "Obtener artefactos".
      this.khArtifacts = result?.artifacts || [];
      this.khJobId = result?.jobId ?? null;
      this.mostrarArtefactos = false;

      // Mostramos los resultados en el paso 3 (tabs Casos / Historias).
      this.evidencia.model = true;
      this.flagButton = true;
      this.step = 3;

      this.snackbarMessage = "Knowledge Hub procesado correctamente";
      this.showSnackbar = true;
      this.snackbarColor = "success";
    },
    // Toggle: si estan visibles, los oculta; si no, los obtiene y muestra.
    async toggleArtefactos() {
      if (this.mostrarArtefactos) {
        this.mostrarArtefactos = false;
        return;
      }
      await this.obtenerArtefactos();
    },
    async obtenerArtefactos() {
      this.cargandoArtefactos = true;
      try {
        // Los artefactos ya vienen en el result, pero refrescamos por si el
        // backend los genera aparte (endpoint). Si falla, usamos los actuales.
        if (this.khJobId) {
          try {
            const result = await getKnowledgeResult(this.khJobId);
            if (Array.isArray(result?.artifacts) && result.artifacts.length) {
              this.khArtifacts = result.artifacts;
            }
          } catch (e) {
            console.warn("No se pudo refrescar artefactos, uso los actuales", e);
          }
        }
        this.mostrarArtefactos = true;
      } finally {
        this.cargandoArtefactos = false;
      }
    },
    onKnowledgeHubError() {
      this.knowledgeHubDone = false;
      this.snackbarMessage = "Hubo un error al procesar el Knowledge Hub";
      this.showSnackbar = true;
      this.snackbarColor = "error";
    },
    descargarArchivo() {
      //Descargar el texto editado en transcripcion.
      const blob= new Blob([this.transcripcionTexto || ""],
        {
          type: "text/plain"
        }
      )
      const url= URL.createObjectURL(blob)
      const link = document.createElement("a");
      //link.href = this.contenidoArchivo;
      link.href= url
      link.download = "transcripcion.txt";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url)
    },
    clasifiqueOptions(tab) {
      switch (tab) {
        case "casosprueba":
          return 1;

        case "historiausuario":
          return 2;
      }
    },
    async obtainModelIA() {
      const opt = this.clasifiqueOptions(this.tab);
      const payload = await this.getProyect();

      // Definimos la fuente que el modelo debe procesar:
      //  - "documento": el texto obtenido del documento / historia escrita.
      //  - "audio": el backend usa la transcripcion ya persistida del proyecto.
      if (this.tipoArchivo === "historia_usuario") {
        const texto = (this.textoExtraido || "").trim();
        if (!texto) {
          this.snackbarMessage = "Primero obtén el texto de la historia";
          this.showSnackbar = true;
          this.snackbarColor = "error";
          return;
        }
        payload.fuente = "documento";
        payload.texto = texto;
      } else {
        payload.fuente = "audio";
        const transEditada=(this.transcripcionTexto || "").trim();
        if (transEditada){
          payload.texto = transEditada
        }
      }
      try {
        this.loading = true;
        this.modelProgreso = null;
        this.modelEtapa = "";
        // 1) Iniciamos el trabajo: el backend responde al instante con un
        //    job_id (202) o un 402 si no hay creditos. Ruta relativa para que
        //    funcione en local (proxy) y en prod (nginx).
        console.log("ESTESSS", payload)
        const startResp = await api.post("/login/modelIAAWS/", {
          opcion: opt,
          payload,
        });
        const jobId = startResp.data?.job_id;
        if (!jobId) {
          throw new Error("El servidor no devolvio un job_id");
        }

        // 2) Polling: preguntamos el estado hasta que termine. Asi ninguna
        //    peticion dura mas de ~1s y el WAF/CloudFront no corta (no mas 504).
        const textoM = await this.pollModelIAJob(jobId);
        this.modelProgreso = null;
        this.modelEtapa = "";

        // 3) El "data" del job es identico a lo que regresaba antes.
        if (opt == 1) {
          this.getDataTestCases(textoM);
        } else {
          this.getDataHistory(textoM);
        }
        this.flagButton = true;
        this.loading = false;
        await this.mostrarConfeti();
        this.evidencia.model = true;
        this.snackbarMessage = "Se proceso con exito el modelo de IA";
        this.showSnackbar = true;
        this.snackbarColor = "success";
      } catch (error) {
        this.loading = false;
        this.modelProgreso = null;
        this.modelEtapa = "";
        // El 402 puede venir en el POST inicial (HTTP 402) o a media
        // generacion durante el polling (code "blocked").
        const blocked =
          error?.response?.status === 402 ||
          error?.status === 402 ||
          error?.code === "blocked";
        if (blocked) {
          await swal({
            icon: "warning",
            title: "Creditos Insuficientes",
            text: "Contacta a un administrador para obtener creditos",
            customClass: {
              popup: this.isDark ? "mi-popup" : "mi-popup-2",
              title: "mi-titulo",
            },
          });
        }
        if (error.status === 409) {
          //unidad sin ARN perfil de inferencia configurado
          await swal({
            icon: "warning",
            title: "La unidad no tiene configurado un Perfil de Inferencia",
            text: "Contacta a un administrador para que pueda configurar un ARN",
            customClass: {
              popup: this.isDark ? "mi-popup" : "mi-popup-2",
              title: "mi-titulo",
            },
          });
        }
        console.error(error);
        this.snackbarMessage =
          "Hubo un error en la obtencion de respuesta del modelo IA";
        this.showSnackbar = true;
        this.snackbarColor = "error";
      }
    },
    // Hace polling al estado de un job de modelIAAWS hasta que termine.
    // Devuelve el "data" del job listo, o lanza un error con .code:
    //   "blocked"  -> creditos agotados a media generacion (402)
    //   "timeout"  -> se excedio el tiempo maximo de espera
    //   "error"    -> el backend reporto un fallo en el procesamiento
    async pollModelIAJob(jobId, { interval = 3000, maxWaitMs = 1800000 } = {}) {
      const startedAt = Date.now();
      // eslint-disable-next-line no-constant-condition
      while (true) {
        if (Date.now() - startedAt > maxWaitMs) {
          const e = new Error("El procesamiento excedio el tiempo de espera");
          e.code = "timeout";
          throw e;
        }

        let data;
        try {
          const resp = await api.get(`/login/modelIAAWS/status/${jobId}/`);
          data = resp.data;
        } catch (err) {
          // 402 a media generacion: creditos agotados.
          if (err?.response?.status === 402) {
            const e = new Error(
              err.response.data?.error || "Creditos insuficientes",
            );
            e.code = "blocked";
            throw e;
          }
          throw err;
        }

        if (data.status === "done") {
          return data.data;
        }
        if (data.status === "error") {
          const e = new Error(data.error || "Error en el procesamiento");
          e.code = data.blocked ? "blocked" : "error";
          throw e;
        }

        // status === "processing": guardamos progreso/etapa y reintentamos.
        if (data.status === "processing") {
          this.modelProgreso = data.progress ?? null;
          this.modelEtapa = data.etapa || "";
        }
        await new Promise((resolve) => setTimeout(resolve, interval));
      }
    },

    getDataHistory(history) {
      this.userStories = history.map((hu, index) => {
        const lines = hu.trim().split("\n");

        const codigo = lines[0].trim();

        const resumen = lines.find((line) =>
          line.toLowerCase().startsWith("¿para qué?"),
        );
        return {
          id: index + 1,
          title: codigo.replace("HU", "HU"),
          summary: resumen || "",
          storyText: hu.replace(/^HU-?\d+\s*\[.*?\]\s*\n?/, ""),
          saved: false,
        };
      });
    },
    getDataTestCases(testCase) {
      this.testCases = testCase.map((tc, index) => {
        const lines1 = tc.trim().split("\n");
        const lines = lines1.filter((item) => item.trim() !== "");
        console.log("TTT ", lines);
        var conta = 1;

        const index1 = lines
          .slice(1)
          .findIndex(
            (item) =>
              item.toLowerCase().includes("tabla de pasos:") ||
              item.toLowerCase().includes("| paso | accion |") ||
              item.toLowerCase().includes("tabla de pasos"),
          );
        console.log(index1);
        const resultado = index1 !== -1 ? lines.slice(1, index1 + 1) : [];
        const testCaseTitle = lines[0].trim();
        console.log(resultado);
        console.log(testCaseTitle.replace("Caso de prueba", "").trim()); // este es el name del caso

        var stepsCase = [];

        const stepsFilter = this.generateDataOneFileStep(lines);
        for (let i = 0; i <= stepsFilter.length; i++) {
          console.log(stepsFilter[i]);
          if (stepsFilter[i] == undefined) {
            conta++;
            continue;
          } else {
            console.log("EESSSS", stepsFilter[i])
            var arr = stepsFilter[i]?.split("|");
            console.log("$$$ ", arr);
            stepsCase.push({
              step: conta,
              action: arr[2],
              expected: arr[3],
            });
            conta++;
          }
        }
        console.log("RRR ", resultado);
        var descriptions = this.obtainDescription(resultado);
        // El titulo es todo lo que viene despues de "# Caso de Prueba:".
        // Quitamos los "#" de markdown y el prefijo "Caso de Prueba:" (sin
        // importar mayusculas) para quedarnos con "MTC-XXX-#####-...".
        var cleanTitle = testCaseTitle
          .replace(/^#+\s*/, "")
          .replace(/^caso de prueba\s*:?\s*/i, "")
          .trim();
        return {
          id: index + 1,
          title: cleanTitle,
          description: descriptions || "",
          steps: stepsCase,
          saved: false,
        };
      });
    },
    generateDataOneFileStep(lines) {
      console.log("ESTOOO ", lines);
      // Detecta una fila de paso de la tabla: la primera celda empieza con un
      // numero, con o sin "Step" delante. Acepta los formatos:
      //   | 1 | accion | esperado |
      //   | Step 1 | accion | esperado |
      //   | **Step 1** - titulo | accion | esperado |
      // Excluye el encabezado (| Step | Accion | ...) y el separador (|---|).
      const isStepRow = (linea) =>
        /^\|\s*(\*\*)?\s*(step\s+)?\d+/i.test((linea || "").trim());

      // Las filas de paso SOLO se buscan despues del encabezado "Tabla de
      // pasos". Asi evitamos confundir otras tablas numeradas que aparecen
      // antes en el documento (ej. "Insumos Requeridos" con | 1 | Dispositivo |),
      // las cuales tambien empiezan con numero y romperian el parseo.
      const headerIdx = lines.findIndex((linea) =>
        /tabla de pasos/i.test((linea || "").trim()),
      );
      const search = headerIdx === -1 ? lines : lines.slice(headerIdx + 1);

      const indexPaso = search.findIndex((linea) => isStepRow(linea));
      console.log("999 -- ", indexPaso);
      if (indexPaso === -1) return [];

      var pasos = search.slice(indexPaso);
      var steps = [];
      for (let i = 0; i < pasos.length; i++) {
        let linea = pasos[i].trim();
        if (!isStepRow(pasos[i]) || !isStepRow(pasos[i + 1])) {
          let j = i + 1;
          while (j < pasos.length && !isStepRow(pasos[j])) {
            linea += " " + pasos[j].trim();
            j++;
          }
          steps.push(linea);
          i = j - 1;
        } else {
          steps.push(pasos[i]);
        }
      }
      return steps;
    },
    obtainDescription(description) {
      var textoDesc = "";
      for (let i = 0; i < description.length; i++) {
        textoDesc += description[i] + "\n";
      }
      return textoDesc;
    },
    generateFormatSaveBDTestCases(steps) {
      var stepsText = "";
      for (let i = 0; i < steps.length; i++) {
        let dataStep = steps[i];
        stepsText +=
          "| " +
          dataStep["step"] +
          "." +
          dataStep["action"] +
          "|" +
          dataStep["expected"] +
          "\n";
      }
      console.log("Dalee", stepsText);
      return stepsText;
    },
  },
};
</script>

<style scoped>
.v-app {
  display: block;
  /* Hace que el v-app solo ocupe el espacio necesario */
  width: 100%;
  /* Opcional: Si quieres que ocupe todo el ancho disponible */
  padding: 0;
  /* Sin padding para que el v-app ajuste su tamaño exactamente al contenido */
}

.panel-card {
  min-height: 0;
}

.panel-header {
  padding: 12px 12px;
}

.panel-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 12px;
}

.panel-body::-webkit-scrollbar {
  width: 6px;
}

.panel-body::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0.6);
  border-radius: 6px;
}

.panel-footer {
  padding: 10px 12px 12px;
}

.selected-panel {
  background: #fafafa;
}

/* mini card (más chica) */
.case-mini {
  border: 1px solid #e5e7eb;
  transition: all 0.15s ease;
}

.case-mini:hover {
  border-color: #1976d2;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
}

.case-mini-body {
  position: relative;
  padding: 10px 12px;
}

.case-title {
  font-weight: 700;
  font-size: 14px;
  /* más grande */
  line-height: 1.4;
  white-space: normal;
  /* permite salto de línea */
  word-break: break-word;
  /* corta palabras largas */
  overflow: visible;
  /* evita ocultamiento */
  text-overflow: unset;
  /* quita los ... */
}

.case-desc {
  font-size: 12px;
}

/* checkbox esquina */
.case-check {
  position: absolute;
  top: 6px;
  right: 6px;
  transform: scale(0.85);
}

/* botón X (lado derecho) */
.case-remove {
  position: absolute;
  top: 2px;
  right: 2px;
}

/* empty state */
.empty-selected {
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
  font-size: 13px;
  text-align: center;
  padding: 16px;
}
</style>
